import React from 'react';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { CelestialRoseNavItem } from '@pkg/components';

import { filteredRoseSelector, userCelestialRosesSelector } from '@app/store/selectors/artifacts/celestial-roses';

import { Typography } from '../../DesignSystem';

import './CelestialRosesNavigation.scss';

interface YatCelestialRosesNavigationProps {
    className?: string;
}
export const CelestialRosesNavigation = ({ className = '' }: YatCelestialRosesNavigationProps) => {
    const { t } = useTranslation(['artifacts']);
    const filteredCelestialRoseDisplayItems = useSelector(filteredRoseSelector);
    const userRoseItemMetadata = useSelector(userCelestialRosesSelector);

    function getDisplayName(tokenId) {
        return tokenId !== '' ? `${t('label_celestialrose')} #${tokenId}` : t('label_celestialrose');
    }

    return (
        <nav className={`yat-artifacts__celestial-roses-nav ${className}`}>
            {userRoseItemMetadata?.length > 0 && (
                <Typography className="yat-artifacts__nav__subtitle" type="label" size={16}>
                    {t('my_collection')}
                </Typography>
            )}
            {userRoseItemMetadata.map((item) => {
                return (
                    <CelestialRoseNavItem
                        id={item.id}
                        displayName={getDisplayName(item.token_id)}
                        iconPath={item.icon_path}
                        ownerName={item.owner_name}
                        key={item.id}
                    />
                );
            })}

            {filteredCelestialRoseDisplayItems?.length > 0 && (
                <Typography className="yat-artifacts__nav__subtitle" type="label" size={16}>
                    {t('not_collected')}
                </Typography>
            )}

            {filteredCelestialRoseDisplayItems?.map((item) => {
                return (
                    <CelestialRoseNavItem
                        key={item.id}
                        id={item.id}
                        displayName={getDisplayName(item.token_id)}
                        iconPath={item.icon_path}
                        ownerName={item.owner_name}
                    />
                );
            })}
        </nav>
    );
};
